import React, { useRef } from "react";
// import centerImage from "../images/center_iamge.jpeg";
import centerImage from "../images/unified_compliance_data.jpg";
import leftImage from "../images/left_image.jpeg";
// import rightImage from "../images/right_image.jpeg";
import rightImage from "../images/streamLined_reporting.png";
import empowerImage from "../images/empower-image.svg";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";

const HomeDashboardPart = ({ isWideScreen, screenWidth }) => {
  const { t } = useTranslation();
  const sliderRef = useRef();

  const slideList = [
    {
      imageUrl: empowerImage,
      imgName: "",
    },
    {
      imageUrl: leftImage,
      imgName: t("ease_of_data"),
    },
    {
      imageUrl: centerImage,
      imgName: t("unified_compliance"),
    },
    {
      imageUrl: rightImage,
      imgName: t("streamLined_reporting"),
    },
  ];

  const handleBeforeChange = (oldIndex) => {
    if (screenWidth <= 425 ? oldIndex === 3 : oldIndex === 2) {
      setTimeout(() => {
        sliderRef?.current?.slickGoTo(0);
      }, 2000);
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    afterChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {isWideScreen ? (
        <div className="flex flex-col sm:flex-row h-[auto] sm:h-[500px] lg:h-[650px] xl:h-[670px] 2xl:h-[800px] lg:mt-[-80px]  justify-evenly items-center relative in tentegreatPage mb-[50px] sm:mb-[100px] lg:mb-[0]">
          <div className="max-w-max p-1 rounded-2xl flex flex-col justify-end items-center unset sm:absolute my-[20px] sm:my-[0px] h-[fit-content] top-[0%] left-[2%] 3xl:left-[6%] lg:top-[8%] xl:top-[13%]">
            <img
              src={leftImage}
              className="h-[241px] w-[259px] md:h-[241px] md:w-[259px] lg:h-[200px] lg:w-[220px] xl:w-[260px] 3xl:w-[290px] xl:h-[230px] 3xl:h-[240px] rounded-2xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)]"
              alt="leftImage"
            />
            <p className="sora mt-2">{t("ease_of_data")}</p>
          </div>
          <div className="unset sm:absolute top-[25%] xl:top-[29%] center_image">
            <img
              draggable="false"
              src={centerImage}
              className="lg:w-[410px] xl:w-[500px] 2xl:w-[500px] 3xl:w-[600px] rounded-xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)]"
              alt="dashboardImage"
            />
            <p className="sora mt-2 text-center">{t("unified_compliance")}</p>
          </div>
          <div className="flex flex-col unset sm:absolute justify-center items-center my-[20px] sm:my-[0px] top-[50%] right-[2%] 3xl:right-[6%] lg:top-[60%] xl:top-[55%] 3xl:top-[57%]">
            <img
              src={rightImage}
              className="h-[252px] w-[290px] md:h-[241px] md:w-[289px] lg:h-[190px] xl:h-[230px] lg:w-[230px] xl:w-[270px] 3xl:w-[310px] rounded-2xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)] bg-white"
              alt="rightImage"
            />
            <p className="sora mt-2">{t("streamLined_reporting")}</p>
          </div>
        </div>
      ) : (
        <div className="container mx-auto">
          <Slider {...settings} ref={sliderRef}>
            {slideList.map((item, index) => (
              <div key={index}>
                <div className="m-3 relative">
                  <img
                    draggable="false"
                    src={item.imageUrl}
                    className="w-[450px] min-h-[360px] xl:w-[560px] 2xl:w-[640px] 3xl:w-[750px] object-contain rounded-xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)]"
                    alt="sideImage"
                  />
                  <p className="sora text-center py-2">{item.imgName}</p>
                </div>
              </div>
            ))}

            {/* <div>
                            <div className='m-3'>
                                <img draggable="false" src={leftImage} className='w-[450px] min-h-[360px] xl:w-[560px] 2xl:w-[640px] 3xl:w-[750px] object-contain rounded-xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)]' alt='sideImage' />
                            </div>
                        </div>
                        <div>
                            <div className='m-3'>
                                <img draggable="false" src={centerImage} className='w-[450px] min-h-[360px] xl:w-[560px] 2xl:w-[640px] 3xl:w-[750px] object-contain rounded-xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)]' alt='sideImage' />
                            </div>
                        </div>
                        <div>
                            <div className='m-3'>
                                <img draggable="false" src={rightImage} className='w-[450px] min-h-[360px] xl:w-[560px] 2xl:w-[640px] 3xl:w-[750px] object-contain rounded-xl shadow-[0_0_16px_0_rgba(0,0,0,0.16)]' alt='sideImage' />
                            </div>
                        </div> */}
          </Slider>
        </div>
      )}
    </>
  );
};

export default HomeDashboardPart;
